import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21.672}
    height={16.254}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g id="noun-users-2120769" transform="translate(-.001 -150)">
      <path
        id="Path_197"
        data-name="Path 197"
        className="cls-1"
        d="M755.418 252.709a2.709 2.709 0 1 1-2.709-2.709 2.709 2.709 0 0 1 2.709 2.709"
        transform="translate(-736.454 -98.194)"
      />
      <path
        id="Path_198"
        data-name="Path 198"
        className="cls-1"
        d="M701.859 625h-.451a4.948 4.948 0 0 0-3.653 1.6 7.2 7.2 0 0 1 1.4 4.267v.452h7.675v-1.354a4.964 4.964 0 0 0-4.971-4.965z"
        transform="translate(-685.153 -466.421)"
      />
      <path
        id="Path_199"
        data-name="Path 199"
        className="cls-1"
        d="M157.224 153.612a3.612 3.612 0 1 1-3.612-3.612 3.612 3.612 0 0 1 3.612 3.612"
        transform="translate(-147.29)"
      />
      <path
        id="Path_200"
        data-name="Path 200"
        className="cls-1"
        d="M6.773 625h-.9A5.869 5.869 0 0 0 0 630.865v1.806h12.643v-1.806A5.872 5.872 0 0 0 6.773 625z"
        transform="translate(0 -466.418)"
      />
    </g>
  </svg>
)

export default SvgComponent